services.service('Onesignal', [
    '$q', 'config', 'ExternalScriptLoader',
    function ($q, config, ExternalScriptLoader) {
        var loader = new ExternalScriptLoader();
        var sdkUrl = "https://cdn.onesignal.com/sdks/OneSignalSDK.js";
        var isEnabled = config['onesignal'] && Object.keys(config.onesignal).length > 0;

        if (!isEnabled) {
            console.warn('Onesignal services are disabled');
        }

        this.init = function () {
            if (!isEnabled) {
                return;
            }
            return loader.load(sdkUrl)
                .then(function () {
                    if (!window['OneSignal']) {
                        return $q.reject("sdk is not loaded");
                    }
                })
                .then(function () {
                    OneSignal.push(function () {
                        console.log('ONESIGNAL INITIALIZE SERVICES');
                        OneSignal.init({
                            appId: config.onesignal.appId,
                            safari_web_id: config.onesignal.safariWebId,
                            notifyButton: {
                                enable: false,
                            },
                        });
                    })
                })
                .catch(function (error) {
                    console.warn('Onesignal services are disabled', error.toString());
                    isEnabled = false;
                })
        }

        this.setUserId = function (id) {
            if (!isEnabled) {
                return;
            }
            OneSignal.push(function () {
                console.log('ONESIGNAL SET EXTERNAL USER ID:', id);
                OneSignal.setExternalUserId(id);
            })
        }

        this.removeUserId = function () {
            if (!isEnabled) {
                return;
            }
            OneSignal.push(function () {
                console.log('ONESIGNAL SET REMOVE USER ID');
                OneSignal.removeExternalUserId();
            })
        }

        this.setEmail = function (email) {
            if (!isEnabled) {
                return;
            }
            OneSignal.push(function () {
                console.log('ONESIGNAL SET EMAIL:', email);
                OneSignal.setEmail(email);
            })
        }

        this.removeEmail = function (id) {
            if (!isEnabled) {
                return;
            }
            OneSignal.push(function () {
                console.log('ONESIGNAL REMOVE EMAIL');
                OneSignal.logoutEmail();
            })
        }

        this.setTag = function (event, data) {
            if (!isEnabled) {
                return;
            }
            OneSignal.push(
                function () {
                    console.log('ONESIGNAL SET TAG:', event, data);
                    OneSignal.sendTag(event, data, function (sent) {
                        console.log('Tags sent:', sent);
                    })
                }
            )
        }

        this.getTags = function () {
            if (!isEnabled) {
                return $q.resolve();
            }
            return $q(function (resolve, reject) {
                OneSignal.push(
                    function () {
                        OneSignal.getTags(function (tags) {
                            resolve(tags);
                        })
                    }
                )
            })
        }

        this.isEnabled = function () {
            return isEnabled;
        }

        return this;
    }
]);
